import type { ReactNode } from 'react';
import { PreferencesContext } from './preferencesContext';
import type { DisplayPreferences } from '@/shared/types/preferences.types';

export interface PreferencesProviderProps {
  readonly value: DisplayPreferences;
  readonly children: ReactNode;
}

/**
 * Publishes the active display preferences.
 *
 * Deliberately a plain value carrier with no knowledge of where the preferences came
 * from; the app layer resolves them from the signed-in user's saved settings and passes
 * them in.
 */
export function PreferencesProvider({
  value,
  children,
}: PreferencesProviderProps): React.JSX.Element {
  return <PreferencesContext.Provider value={value}>{children}</PreferencesContext.Provider>;
}
